'use strict';

var _ = require('lodash');

/**
 * Brush Extent Service
 * @constructor
 */
var BrushExtentService = function BrushExtentService() {
  var oldDelta = 0;

  /**
   * Restrains extent to domain length
   * @param {Array} extent
   * @param {number} domainLength
   * @returns {Array}
   */
  function handleExtentEdgeCases(extent, domainLength) {
    if (extent[0] >= domainLength) {
      extent[0] = domainLength - 1;
    }
    if (extent[1] <= extent[0]) {
      extent[1] = extent[0] + 1;
    }
    return extent;
  }
  function countDelta(brushExtent) {
    var delta = brushExtent[1] - brushExtent[0] || 1;
    if (oldDelta !== delta) {
      if (oldDelta > 0) {
        delta = oldDelta;
      }
      oldDelta = delta;
    }
    return delta;
  }

  /**
   * Converts extent to integer
   * @param {Array} brushExtent
   * @param {string} eventMode
   * @returns {Array}
   */
  function roundExtent(brushExtent, eventMode) {
    switch (eventMode) {
      case 'move':
        brushExtent[0] = Math.round(brushExtent[0]);
        brushExtent[1] = Math.round(brushExtent[1]);
        var delta = countDelta(brushExtent);
        brushExtent[1] = brushExtent[0] + delta;
        return brushExtent;
      case 'resize':
        //Yes i'm sorry for this.... (floating point precision hack).
        //PS. parseInt() doesn't cut it.
        oldDelta = 0;
        return [Math.floor(brushExtent[0] + 0.00005), Math.ceil(brushExtent[1] - 0.00005)];
    }
  }

  /**
   * Restrains extent to given size
   * @param {Object} sizeRange
   * @param {Array} currentSelection
   * @param {Array} roundedExtent
   * @param {number} domainLength
   * @returns {Array}
   */
  function adjustBrushToPermittedSize(sizeRange, currentSelection, roundedExtent, domainLength) {
    if (!sizeRange) {
      return roundedExtent;
    }
    var begin = roundedExtent[0];
    var end = roundedExtent[1];
    var brushSize = end - begin;
    if (_.isNumber(sizeRange.max) && brushSize > sizeRange.max) {
      if (currentSelection[0] === begin) {
        roundedExtent[1] = begin + sizeRange.max;
      } else {
        roundedExtent[0] = end - sizeRange.max;
      }
    } else if (_.isNumber(sizeRange.min) && brushSize < sizeRange.min) {
      if (currentSelection[0] !== begin && currentSelection[1] !== end) {
        if (currentSelection[0] > begin) {
          roundedExtent[1] = begin + sizeRange.min;
        } else {
          roundedExtent[0] = end - sizeRange.min;
          if (roundedExtent[0] < 0) {
            roundedExtent[0] = 0;
          }
          roundedExtent[1] = roundedExtent[0] + sizeRange.min;
        }
      } else {
        if (currentSelection[0] === begin) {
          roundedExtent[1] = begin + sizeRange.min;
          if (roundedExtent[1] > domainLength) {
            roundedExtent[1] = domainLength;
          }
        } else {
          roundedExtent[0] = end - sizeRange.min;
          if (roundedExtent[0] < 0) {
            roundedExtent[0] = 0;
          }
        }
      }
    }
    return roundedExtent;
  }
  return {
    roundExtent: roundExtent,
    handleExtentEdgeCases: handleExtentEdgeCases,
    adjustBrushToPermittedSize: adjustBrushToPermittedSize
  };
};
BrushExtentService.$inject = [];
module.exports = BrushExtentService;